import { useEffect, useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { Heart, HeartHandshake } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PalestineCounter = ({ variant = "dark", testId = "palestine-counter" }) => {
  const [data, setData] = useState(null);
  useEffect(() => {
    axios.get(`${API}/cause/palestine`).then((r) => setData(r.data)).catch(() => setData({ pieces: 0, orders: 0 }));
  }, []);
  if (!data) return null;
  const dark = variant === "dark";
  const n = data.pieces;
  const raised = (data.donated_cents || 0) / 100;
  const raisedLabel = raised >= 1000 ? `$${Math.floor(raised).toLocaleString()}` : `$${raised.toFixed(raised % 1 ? 2 : 0)}`;
  const divider = dark ? "border-[#f5f4ee]/15" : "border-white/15";
  return (
    <motion.div
      data-testid={testId}
      initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
      className={`grid sm:grid-cols-2 rounded-3xl border ${dark ? "bg-[#f5f4ee]/[0.04] border-[#f5f4ee]/15 text-[#f5f4ee]" : "bg-[#0a0a0b] border-[#0a0a0b] text-white"}`}
    >
      <div className={`flex items-center gap-4 p-6 sm:p-7 border-b sm:border-b-0 sm:border-r ${divider}`}>
        <span className="h-12 w-12 shrink-0 rounded-full bg-[#007a3d] text-white flex items-center justify-center"><HeartHandshake size={20} /></span>
        <div className="min-w-0">
          <p className="font-mono-d text-[10px] uppercase tracking-[0.25em] text-[#ff2a85]">Giving back · live</p>
          <p className="mt-1 leading-tight">
            <span data-testid="palestine-counter-pieces" className="font-display font-extrabold text-4xl sm:text-5xl tabular-nums">{n}</span>
            <span className="ml-2 font-display font-extrabold uppercase text-base sm:text-lg">Palestine Edition {n === 1 ? "piece" : "pieces"} pre-ordered</span>
          </p>
          <p className={`mt-1.5 text-sm leading-snug ${dark ? "text-[#f5f4ee]/70" : "text-white/75"}`}>
            {n === 0 ? "Be the first — every Palestine Edition piece gives back to the Palestine cause." : `Each one gives back to the Palestine cause. ${data.orders} ${data.orders === 1 ? "believer" : "believers"} so far.`}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-4 p-6 sm:p-7">
        <span className="h-12 w-12 shrink-0 rounded-full bg-[#ff2a85] text-white flex items-center justify-center"><Heart size={20} fill="currentColor" /></span>
        <div className="min-w-0">
          <p className="font-mono-d text-[10px] uppercase tracking-[0.25em] text-[#007a3d]">Donations · live</p>
          <p className="mt-1 leading-tight">
            <span data-testid="palestine-counter-raised" className="font-display font-extrabold text-4xl sm:text-5xl tabular-nums">{raisedLabel}</span>
            <span className="ml-2 font-display font-extrabold uppercase text-base sm:text-lg">raised for Palestine so far</span>
          </p>
          <p className={`mt-1.5 text-sm leading-snug ${dark ? "text-[#f5f4ee]/70" : "text-white/75"}`}>
            {data.donors ? `${data.donors} ${data.donors === 1 ? "donor" : "donors"} added a gift at checkout. Jazakum Allahu khayran.` : "Add a donation to your order at checkout — every contribution counts."}
          </p>
        </div>
      </div>
    </motion.div>
  );
};
